export default "__VITE_ASSET__BUW4vr4Z__"